/* TDLS Splide init — brands, products, testimonials */
(function () {
  function initBrands(root) {
    (root || document).querySelectorAll('.tdls-brands-splide:not(.is-initialized)').forEach(function (el) {
      var splide = new Splide(el, {
        type: 'loop',
        perPage: 8,
        perMove: 1,
        gap: '3rem',
        arrows: false,
        pagination: false,
        drag: 'free',
        autoScroll: {
          speed: 0.6,
          pauseOnHover: true,
          pauseOnFocus: false
        },
        breakpoints: {
          1024: { perPage: 6, gap: '2rem' },
          767: { perPage: 4, gap: '1.5rem' },
          480: { perPage: 3, gap: '1rem' }
        }
      });
      splide.mount(window.splide ? window.splide.Extensions : {});
    });
  }

  function initProducts(root) {
    (root || document).querySelectorAll('.tdls-products-splide:not(.is-initialized)').forEach(function (el) {
      var splide = new Splide(el, {
        type: 'loop',
        perPage: 4,
        perMove: 1,
        gap: '1.5rem',
        padding: { left: '2rem', right: '2rem' },
        arrows: false,
        pagination: false,
        autoScroll: {
          speed: 0.4,
          pauseOnHover: true,
          pauseOnFocus: true
        },
        breakpoints: {
          1024: { perPage: 3 },
          767: { perPage: 2, gap: '1rem', padding: { left: '1rem', right: '1rem' } },
          480: { perPage: 1, gap: '1rem', padding: { left: '2rem', right: '2rem' } }
        }
      });
      splide.mount(window.splide ? window.splide.Extensions : {});
    });
  }

  function initTestimonials(root) {
    (root || document).querySelectorAll('.tdls-testimonials-splide:not(.is-initialized)').forEach(function (el) {
      var splide = new Splide(el, {
        type: 'loop',
        perPage: 3,
        perMove: 1,
        focus: 'center',
        gap: '2rem',
        padding: { left: '5rem', right: '5rem' },
        arrows: false,
        pagination: false,
        autoScroll: {
          speed: 0.5,
          pauseOnHover: true,
          pauseOnFocus: true
        },
        breakpoints: {
          767: {
            perPage: 1,
            gap: '1rem',
            padding: { left: '2rem', right: '2rem' }
          }
        }
      });
      splide.mount(window.splide ? window.splide.Extensions : {});
    });
  }

  function initAll(root) {
    initBrands(root);
    initProducts(root);
    initTestimonials(root);
  }

  /* Wait for Splide to load (deferred script) */
  function ready() {
    if (typeof Splide !== 'undefined') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        var check = setInterval(function () {
          if (typeof Splide !== 'undefined') {
            clearInterval(check);
            initAll();
          }
        }, 50);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  /* Re-init on Shopify editor section load */
  document.addEventListener('shopify:section:load', function (e) {
    setTimeout(function () { initAll(e.target); }, 100);
  });
})();
